import React, { Fragment } from "react";
import {
  AutocompleteInput,
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  Filter,
  FunctionField,
  List,
  NullableBooleanInput,
  NumberField,
  Pagination,
  ReferenceInput,
  SelectInput,
  TextField,
  TextInput,
  translate,
  WithPermissions
} from "react-admin";
import { push } from "react-router-redux";
import {
  isAdmin,
  isClubAdmin,
  isPortalAdmin,
  isShooter
} from "../../utils/utils";
import CancelButton from "../../components/CancelButton";
import CancelCompetitionPopup from "../../components/CancelCompetitionPopup";
import CopyButton from "../../components/CopyButton";
import { setPopup, togglePopup } from "../../reducer/flagActions";
import { connect } from "react-redux";
import {
  getClub,
  payCompetition,
  updateCompetitionCancel,
  updateForceCompetitionCancel
} from "../../utils/restUtils";
import { setError } from "../../reducer/errorActions";
import Grid from "@material-ui/core/Grid";
import PageTitle from "../../components/PageTitle";
import { DateInput } from "react-admin-date-inputs";
import LinkIcon from "@material-ui/icons/Link";
import { IconButton } from "@material-ui/core";
import {
  defaultRowsPerPageOption,
  rowsPerPageOptions
} from "../../utils/paging";
import PopupBulkDeleteButton from "../../components/PopupBulkDeleteButton";
import PopupBulkCompetitionButton from "../../components/PopupBulkCompetitionButton";
import deLocale from "date-fns/locale/de";
import CompetitionInvoicePopup from "../../components/CompetitionInvoicePopup";
import ReceiptIcon from "@material-ui/icons/Receipt";
import GenericPopup from "../../components/GenericPopup";
import { setSuccess } from "../../reducer/successActions";
import CheckIcon from "@material-ui/icons/Check";
import InfoIcon from "@material-ui/icons/Info";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import CompetitionDetailsPopup from "../../components/CompetitionDetailsPopup";

const ClubListRenderer = ({ record }) => (
  <span style={{ display: "block", marginRight: "3px" }}>{record.name}</span>
);

const CompetitionFilter = translate(props => (
  <WithPermissions
    render={({ permissions }) => (
      <Filter {...props}>
        {(isAdmin(permissions) || isPortalAdmin(permissions)) && (
          <ReferenceInput
            alwaysOn
            source="clubId"
            reference="clubs"
            filter={{ active: true }}
            perPage={100}
            sort={{ field: "name", order: "ASC" }}
            label="resources.competitions.listPage.filters.club"
          >
            <AutocompleteInput
              optionValue="id"
              options={{
                suggestionsContainerProps: {
                  modifiers: { keepTogether: { enabled: true } }
                }
              }}
            />
          </ReferenceInput>
        )}
        <TextInput alwaysOn source="name" />
        <ReferenceInput
          alwaysOn
          perPage={100}
          sort={{ field: "name", order: "ASC" }}
          filter={{ event: false }}
          source="competitionTypeId"
          reference="competitionTypes"
        >
          <SelectInput optionText={<ClubListRenderer />} optionValue="id" />
        </ReferenceInput>
        <DateInput
          alwaysOn
          label={props.translate(
            "resources.competitions.listPage.filters.dateFrom"
          )}
          source="dateFrom"
          options={{
            format: "dd.MM.YYYY",
            ampm: false,
            clearable: true
          }}
          locale={deLocale}
        />
        <DateInput
          alwaysOn
          label={props.translate(
            "resources.competitions.listPage.filters.dateTo"
          )}
          source="dateTo"
          options={{
            format: "dd.MM.YYYY",
            ampm: false,
            clearable: true
          }}
          locale={deLocale}
        />
        {(isAdmin(permissions) || isPortalAdmin(permissions)) && [
          <NullableBooleanInput
            style={{ width: "200px" }}
            label={props.translate(
              "resources.competitions.listFilter.paidFilter"
            )}
            source="notPaid"
            alwaysOn
          />,
          <NullableBooleanInput
            style={{ width: "200px" }}
            label={props.translate(
              "resources.competitions.listFilter.amountFilter"
            )}
            source="invoiceAmount"
            alwaysOn
          />
        ]}
        {(isAdmin(permissions) || isPortalAdmin(permissions)) && [
          <SelectInput
            style={{ width: "200px" }}
            label={props.translate(
              "resources.competitions.listFilter.viewType"
            )}
            source="viewType"
            alwaysOn
            choices={[
              {
                id: "ALL",
                name: props.translate(
                  "resources.competitions.fields.viewType.all"
                )
              },
              {
                id: "INTERNAL",
                name: props.translate(
                  "resources.competitions.fields.viewType.internal"
                )
              },
              {
                id: "EXTERNAL",
                name: props.translate(
                  "resources.competitions.fields.viewType.external"
                )
              },
              {
                id: "UNLISTED",
                name: props.translate(
                  "resources.competitions.fields.viewType.unlisted"
                )
              }
            ]}
          />,
          <DateInput
            alwaysOn
            label={props.translate(
              "resources.competitions.listPage.filters.registrationStartFrom"
            )}
            source="registrationStartFrom"
            options={{
              format: "dd.MM.YYYY",
              ampm: false,
              clearable: true
            }}
            locale={deLocale}
          />,
          <DateInput
            alwaysOn
            label={props.translate(
              "resources.competitions.listPage.filters.registrationStartTo"
            )}
            source="registrationStartTo"
            options={{
              format: "dd.MM.YYYY",
              ampm: false,
              clearable: true
            }}
            locale={deLocale}
          />
        ]}
      </Filter>
    )}
  />
));

const mapStateToProps = state => ({
  cancelCompetitionPopupOpen: state.flags.popupOpen.popupCancelCompetition,
  cancelCompetitionData: state.flags.data.popupCancelCompetition,
  competitionInvoicePopupOpen: state.flags.popupOpen.popupCompetitionInvoice,
  competitionInvoiceData: state.flags.data.popupCompetitionInvoice,
  competitionPayPopupOpen: state.flags.popupOpen.popupCompetitionPay,
  competitionPayData: state.flags.data.popupCompetitionPay,
  competitionDetailsPopupOpen: state.flags.popupOpen.popupCompetitionDetails,
  competitionDetailsData: state.flags.data.popupCompetitionDetails,
  httpErrorMsg: state.error.httpError.message
});

const mapDispatchToProps = dispatch => ({
  push,
  dispatch
});

const CompetitionActions = ({
  basePath,
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => (
  <div>
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button"
      })}
    <CreateButton basePath={basePath} />
  </div>
);

export const CompetitionList = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(props => {
    if (props.permissions && isShooter(props.permissions)) {
      props.dispatch(push("/competitionList"));
    }

    const doCancelCompetition = doCancel => {
      let data = { id: props.cancelCompetitionData.id, cancelled: !doCancel };
      updateCompetitionCancel(data).then(
        data => {
          props.dispatch(togglePopup("popupCancelCompetition"));
          props.dispatch(push("/competitions_"));
          props.dispatch(push("/competitions"));
          //props.history.push("/users");
          props.dispatch(setError(null));
        },
        e => {
          props.dispatch(setError(e));
        }
      );
    };
    const doForceCancelCompetition = doCancel => {
      let data = { id: props.cancelCompetitionData.id, cancelled: !doCancel };
      updateForceCompetitionCancel(data).then(
        data => {
          props.dispatch(togglePopup("popupCancelCompetition"));
          props.dispatch(push("/competitions_"));
          props.dispatch(push("/competitions"));
          props.dispatch(setError(null));
        },
        e => {
          props.dispatch(setError(e));
        }
      );
    };

    const invoiceClosed = () => {
      setTimeout(() => {
        props.dispatch(togglePopup("popupCompetitionInvoice"));
        props.dispatch(push("/competitions_"));
        props.dispatch(push("/competitions"));
        //props.history.push("/users");
        props.dispatch(setError(null));
      }, 200);
    };

    const handlePaid = () => {
      payCompetition(
        props.competitionPayData.id,
        !props.competitionPayData.paid
      ).then(() => {
        props.dispatch(
          setSuccess({
            message: "resources.competitions.listPage.paidSuccess"
          })
        );
        props.dispatch(togglePopup("popupCompetitionPay"));
        props.dispatch(push("/competitions_"));
        props.dispatch(push("/competitions"));
      });
    };

    const copy = require("clipboard-copy");
    const currentUrl = window.location;
    const basePath =
      currentUrl.protocol +
      "//" +
      currentUrl.host +
      "/" +
      currentUrl.pathname.split("/")[1];

    const PostPagination = props => (
      <Pagination rowsPerPageOptions={rowsPerPageOptions} {...props} />
    );

    const adminRowStyle = record => {
      if (record.active) {
        if (record.paid) {
          return {
            backgroundColor: "white"
          };
        } else if (record.viewType === "UNLISTED") {
          return {
            backgroundColor: "#9999ff"
          };
        } else if (record.viewType === "INTERNAL") {
          return {
            backgroundColor: "#aaffaa"
          };
        } else {
          return {
            backgroundColor: "#ff6666"
          };
        }
      } else {
        return {
          backgroundColor: record.paid ? "lightgrey" : "#aa3333",
          textDecoration: "line-through"
        };
      }
    };

    const bulkAction = isAdmin(props.permissions) ? (
      <PopupBulkCompetitionButton />
    ) : (
      <PopupBulkDeleteButton />
    );

    const toggleInvoice = (props, competition) => {
      getClub(competition.club.id).then(club => {
        competition.club = club;
        props.dispatch(togglePopup("popupCompetitionInvoice", competition));
      });
    };

    const togglePay = (props, competition) => {
      props.dispatch(togglePopup("popupCompetitionPay", competition));
    };
    const toggleDetails = (props, competition) => {
      props.dispatch(togglePopup("popupCompetitionDetails", competition));
    };

    return (
      <WithPermissions
        render={({ permissions }) => (
          <Fragment>
            <Grid>
              <PageTitle
                title={props.translate(
                  isClubAdmin(permissions)
                    ? "competitionList.titleClubAdmin"
                    : "competitionList.titleAdmin"
                )}
              />
              <List
                {...props}
                bulkActionButtons={bulkAction}
                perPage={defaultRowsPerPageOption}
                pagination={<PostPagination />}
                filters={<CompetitionFilter />}
                exporter={false}
                actions={<CompetitionActions permissions={permissions} />}
              >
                <Datagrid
                  rowStyle={
                    isAdmin(permissions) || isPortalAdmin(permissions)
                      ? adminRowStyle
                      : null
                  }
                >
                  {isAdmin(permissions) ? (
                    <TextField source="club.name" />
                  ) : null}
                  <TextField source="name" />
                  <TextField source="competitionTypeName" />

                  <FunctionField
                    source="publicLink"
                    label={"Link"}
                    headerClassName={"center"}
                    render={record => (
                      <Fragment>
                        <IconButton
                          onClick={e => {
                            props.dispatch(
                              setPopup(
                                "popupCompetitionRegistrationForm",
                                false
                              )
                            );
                            if (window) {
                              window.open(
                                basePath +
                                  "#/competitionDetails/" +
                                  record.publicLink
                              );
                            } else {
                              copy(
                                basePath +
                                  "#/competitionDetails/" +
                                  record.publicLink
                              );
                            }
                          }}
                        >
                          <LinkIcon />
                        </IconButton>
                      </Fragment>
                    )}
                  />

                  <DateField locales="de-DE" source="competitionDate" />
                  {(isAdmin(permissions) || isPortalAdmin(permissions)) && (
                    <FunctionField
                      source="viewType"
                      label={"S"}
                      render={record => [
                        record.cancelled ? (
                          <span>A</span>
                        ) : record.viewType === "ALL" ? (
                          <span>Ü</span>
                        ) : record.viewType === "INTERNAL" ? (
                          <span>I</span>
                        ) : record.viewType === "EXTERNAL" ? (
                          <span>E</span>
                        ) : (
                          <span>V</span>
                        )
                      ]}
                    />
                  )}
                  <NumberField
                    source="nominationFee"
                    locales="de-DE"
                    options={{ style: "currency", currency: "EUR" }}
                  />

                  <DateField
                    locales="de-DE"
                    source="registrationStart"
                    showTime
                  />
                  <DateField
                    locales="de-DE"
                    source="registrationEnd"
                    showTime
                  />

                  <FunctionField
                    render={record => [
                      record.active ? (
                        <CancelButton
                          itemId={record.id}
                          cancelHandler={() =>
                            props.dispatch(
                              togglePopup("popupCancelCompetition", {
                                id: record.id,
                                isCancelled: record.cancelled
                              })
                            )
                          }
                          isCancelled={record.cancelled}
                          setLabel="resources.competitions.cancelButton.cancel"
                          unsetLabel="resources.competitions.cancelButton.unCancel"
                        />
                      ) : null,
                      <CopyButton
                        itemId={record.id}
                        clickHandler={() =>
                          props.dispatch(
                            push("/competitions/copy/" + record.id)
                          )
                        }
                        isCancelled={record.cancelled}
                      />
                    ]}
                  />
                  <EditButton label="" />
                  {(isAdmin(permissions) || isPortalAdmin(permissions)) && (
                    <FunctionField
                      render={record => [
                        <IconButton
                          onClick={() => {
                            toggleInvoice(props, record);
                          }}
                          style={{ width: "24px" }}
                        >
                          <ReceiptIcon />
                        </IconButton>,
                        <IconButton
                          onClick={() => {
                            togglePay(props, record);
                          }}
                          style={{ width: "24px" }}
                        >
                          <CheckIcon />
                        </IconButton>,
                        <IconButton
                          onClick={() => {
                            toggleDetails(props, record);
                          }}
                          style={{ width: "24px" }}
                        >
                          <InfoIcon />
                        </IconButton>
                      ]}
                    />
                  )}
                </Datagrid>
              </List>
              <CancelCompetitionPopup
                open={props.cancelCompetitionPopupOpen}
                handleClose={() => {
                  props.dispatch(togglePopup("popupCancelCompetition"));
                  props.dispatch(setError(null));
                }}
                handleCancel={() =>
                  doCancelCompetition(props.cancelCompetitionData.isCancelled)
                }
                handleForceCancel={() =>
                  doForceCancelCompetition(
                    props.cancelCompetitionData.isCancelled
                  )
                }
                isCancelled={
                  props.cancelCompetitionData
                    ? props.cancelCompetitionData.isCancelled
                    : false
                }
                errorMessage={props.httpErrorMsg}
              />
              <CompetitionInvoicePopup
                open={props.competitionInvoicePopupOpen}
                handleClose={() => invoiceClosed()}
                competition={props.competitionInvoiceData}
                errorMessage={props.httpErrorMsg}
              />
              <GenericPopup
                open={props.competitionPayPopupOpen}
                handleConfirm={() => handlePaid()}
                handleClose={() => {
                  props.dispatch(togglePopup("popupCompetitionPay"));
                }}
                message={props.translate(
                  "resources.orderList.payOrderItemPopup.warning"
                )}
                title={props.translate(
                  props.competitionPayData && props.competitionPayData.paid
                    ? "resources.orderList.unPayOrderItemPopup.title"
                    : "resources.orderList.payOrderItemPopup.title"
                )}
                confirmText={props.translate(
                  "resources.orderList.payOrderItemPopup.confirm"
                )}
                cancelText={props.translate(
                  "resources.orderList.payOrderItemPopup.cancel"
                )}
              />

              <CompetitionDetailsPopup
                open={props.competitionDetailsPopupOpen}
                handleClose={() =>
                  props.dispatch(togglePopup("popupCompetitionDetails"))
                }
                competition={props.competitionDetailsData}
                errorMessage={props.httpErrorMsg}
              />
            </Grid>
          </Fragment>
        )}
      />
    );
  })
);
